class ConsentManager {
    constructor() {
        this.consentState = "";
        const self = this;
        document.addEventListener("DOMContentLoaded", () => {
            if (typeof jQuery === 'undefined') {
                return;
            }
            try {
                $(document).ready(() => {
                    $(document).on('click', '#onetrust-accept-btn-handler', () => { self.raiseGTMEvent('onetrust_accept', 'Clicked on OT Accept button'); });
                    $(document).on('click', '#accept-recommended-btn-handler', () => { self.raiseGTMEvent('onetrust_customize', 'Clicked on OT Customize button'); });
                    $(document).on('click', '.save-preference-btn-handler', () => { self.raiseGTMEvent('onetrust_customize', 'Clicked on OT Customize button'); });
                });
            } catch (e) {
                console.error("Error in ConsentManager constructor", e);
            }
        });
    }

    checkandDoRefresh() {
        if (this.consentState != "" && !this.compareCookieValue(this.consentState, OnetrustActiveGroups)) {
            document.body.innerHTML = "";
            location.reload();
            return;
        }

        this.consentState = OnetrustActiveGroups;
        this.setGoogleAnalyticsMeta();
        this.setVariables();
        this.setConsentAlertAttr();
        this.showHideContentCategory();
        window.dataLayer.push({ event: 'OneTrustGroupsUpdated' });
        const self = this;
        document.addEventListener("DOMContentLoaded", () => {
            self.showHideContentCategory();
        });
    }

    setGoogleAnalyticsMeta() {
        var metaTag = document.querySelector('meta[name="gdpr_googleanalytics"]');
        if (!metaTag) {
            return;
        }

        if (!this.isCategoryActive("GoogleAnalytics")) {
            metaTag.content = "False";
        }
    }

    setVariables() {
        const consentGroups = OnetrustActiveGroups.split(',').map(item => item.trim()).filter(item => item !== '');
        const isPerformanceActive = consentGroups.includes('C0002');
        const isFunctionalActive = consentGroups.includes('C0003');
        const isTargetingActive = consentGroups.includes('C0004');

        let pardotCookieValue = "";

        if (typeof pardotCookieKey !== 'undefined' && pardotCookieKey) {
            pardotCookieValue = this.getCookieValue(pardotCookieKey);
        }

        const parameters = {};
        parameters.isPerformanceActive = isPerformanceActive;
        parameters.isFunctionalActive = isFunctionalActive;
        parameters.isTargetingActive = isTargetingActive;
        parameters.pardotCookieValue = pardotCookieValue;

        this.updatePageVariables(parameters);
        this.updateDataLayerVariables(parameters);
    }

    updateDataLayerVariables(parameters) {
        if (typeof dataLayer === 'undefined' || !dataLayer || dataLayer.length === 0) {
            return;
        }

        if (parameters.isPerformanceActive) {
            dataLayer[0].is_performance_active = "True";
        }
        if (parameters.isFunctionalActive) {
            dataLayer[0].is_functional_active = "True";
        }
        if (parameters.isTargetingActive) {
            dataLayer[0].is_targeting_active = "True";
        }
        if (parameters.pardotCookieValue) {
            dataLayer[0].pardot_cookie_id = parameters.pardotCookieValue;
        }
    }

    updatePageVariables(parameters) {
        if (typeof pageVariables === "undefined" || !pageVariables) {
            return;
        }

        if (parameters.isPerformanceActive) {
            pageVariables.IsPerformanceActive = "True";
        }
        if (parameters.isFunctionalActive) {
            pageVariables.IsFunctionalActive = "True";
        }
        if (parameters.isTargetingActive) {
            pageVariables.IsTargettingActive = "True";
        }
        if (parameters.pardotCookieValue) {
            pageVariables.PardotCookieId = parameters.pardotCookieValue;
        }
    }

    setConsentAlertAttr() {
        const consentAlert = document.querySelector(".cookie-consent-warning");

        if (!consentAlert) {
            return;
        }

        consentAlert.style.display = "none";

        const components = document.querySelectorAll("[data-cookie]:not([data-ignore-alert])");

        if (components.length == 0) {
            return;
        }

        const categories = Array.from(new Set(
            Array.from(components)
                .map(item => item.getAttribute("data-cookie").split("-"))
                .flat()
                .filter(item => item !== '')
        )).join("-");

        consentAlert.setAttribute("data-category-hide", categories);
    }

    showHideContentCategory() {
        const consentGroups = new Set(OnetrustActiveGroups.split(',').map(item => item.trim()).filter(item => item !== ''));
        const elements = document.querySelectorAll('[data-category-show], [data-category-hide]');
        elements.forEach(element => {
            const showGroups = element.getAttribute('data-category-show')?.split('-') || [];
            const hideGroups = element.getAttribute('data-category-hide')?.split('-') || [];

            if (showGroups.length > 0 && showGroups.every(group => consentGroups.has(group))) {
                element.style.display = 'block';
            }

            if (hideGroups.length > 0 && hideGroups.some(group => !consentGroups.has(group))) {
                element.style.display = 'block';
            }
        });
    }

    compareCookieValue(str1, str2) {
        const arr1 = str1.split(',').map(item => item.trim()).filter(item => item !== '').sort();
        const arr2 = str2.split(',').map(item => item.trim()).filter(item => item !== '').sort();

        return arr1.join(',') === arr2.join(',');
    }

    raiseGTMEvent(eventName, eventAction) {
        const GTMData = {
            'event': 'gaCustomEvents_' + eventName,
            'eventAction': eventAction,
            'eventCategory': 'OneTrust Consent'
        };
        dataLayer.push(GTMData);
    }

    isCategoryActive(componentName) {
        if (typeof OnetrustActiveGroups === 'undefined') {
            return true;
        }

        if (!OnetrustActiveGroups) {
            return false;
        }

        if (!componentCategories) {
            return false;
        }

        const activeConsentGroups = new Set(OnetrustActiveGroups.split(',').map(item => item.trim()).filter(item => item !== ''));
        const componentGroups = componentCategories
            .filter(group => group.ComponentName === componentName)
            .map(group => group.Category);

        if (componentGroups.length === 0) {
            return true;
        }

        //all the componentGroups should present in activeConsentGroups
        return componentGroups.every(group => activeConsentGroups.has(group));
    }

    getCookieValue(cookieName) {
        const cookies = document.cookie.split("; ").map(cookie => cookie.split("="));
        const cookie = cookies.find(([name]) => name === cookieName);
        return cookie ? decodeURIComponent(cookie[1]) : "";
    }
}

const consentManager = new ConsentManager();
function OptanonWrapper() {
    consentManager.checkandDoRefresh();
}